package com.siriusxm.pia.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

/**
 * A standard row of elements
 */
@Composable
fun Row(
    gap: CSSNumeric? = null,
    style: StyleScope.()->Unit = {},
    content: @Composable () -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Row)
            width(100.percent)
            if (gap != null) {
                gap(gap)
            }
            style()
        }
    }) {
        content()
    }
}

/**
 * A standard column of elements.
 */
@Composable
fun Column(
    gap: CSSNumeric? = null,
    style: StyleScope.()->Unit = {},
    content: @Composable () -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            width(100.percent)
            if (gap != null) {
                gap(gap)
            }
            style()
        }
    }) {
        content()
    }
}

